// HomeRing.js
// 64px progress ring showing value/max. On web this is a real CSS
// conic-gradient (react-native-web passes unrecognized style keys through
// to the DOM); on native it falls back to a plain bordered circle since
// RN has no conic-gradient primitive.
import React from "react";
import { View, Text, StyleSheet, Platform } from "react-native";

import { HOME, homeColors } from "../homeTheme";

const SIZE = 64;

const HomeRing = ({
  value,
  max,
  label,
  sublabel = null,
  sublabelTone = null,
  isDarkMode = false,
  testID,
}) => {
  const colors = homeColors(isDarkMode);
  const safeMax = Number(max) > 0 ? Number(max) : 0;
  const pct = safeMax > 0 ? Math.min(1, Number(value) / safeMax) : 0;
  const sublabelColor = sublabelTone === "ok" ? colors.green : colors.textSecondary;

  const ringStyle =
    Platform.OS === "web"
      ? {
          background: `conic-gradient(${colors.brand} ${pct * 360}deg, ${colors.line} 0deg)`,
        }
      : { borderWidth: HOME.heroRing, borderColor: colors.brand };

  return (
    <View style={styles.wrap}>
      <View testID={testID} style={[styles.ring, ringStyle]}>
        <View style={[styles.inner, { backgroundColor: colors.cardBg }]}>
          <Text style={[styles.value, { color: colors.textPrimary }]}>
            {`${value}/${max}`}
          </Text>
        </View>
      </View>
      <View style={styles.textCol}>
        <Text style={[styles.label, { color: colors.textPrimary }]}>{label}</Text>
        {sublabel ? (
          <Text style={[styles.sublabel, { color: sublabelColor }]}>
            {sublabel}
          </Text>
        ) : null}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  wrap: { flexDirection: "row", alignItems: "center", gap: 12 },
  ring: {
    width: SIZE,
    height: SIZE,
    borderRadius: SIZE / 2,
    alignItems: "center",
    justifyContent: "center",
  },
  inner: {
    width: SIZE - 14,
    height: SIZE - 14,
    borderRadius: (SIZE - 14) / 2,
    alignItems: "center",
    justifyContent: "center",
  },
  value: { fontSize: 14, fontWeight: "700" },
  textCol: { flex: 1 },
  label: { fontSize: 13, fontWeight: "600" },
  sublabel: { fontSize: 12, marginTop: 2 },
});

export default HomeRing;
